import CardImageSlider from './CardImagesSlider';

export default CardImageSlider;
